<template>
  <svg :width="width" :height="height" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M14.9997 9.16667H4.99967C4.55765 9.16667 4.13372 9.34226 3.82116 9.65482C3.5086 9.96738 3.33301 10.3913 3.33301 10.8333V17.5C3.33301 17.942 3.5086 18.3659 3.82116 18.6785C4.13372 18.9911 4.55765 19.1667 4.99967 19.1667H14.9997C15.4417 19.1667 15.8656 18.9911 16.1782 18.6785C16.4907 18.3659 16.6663 17.942 16.6663 17.5V10.8333C16.6663 10.3913 16.4907 9.96738 16.1782 9.65482C15.8656 9.34226 15.4417 9.16667 14.9997 9.16667ZM14.9997 14.1667H4.99967V11.6667H14.9997V14.1667ZM14.1663 4.16667V8.33333H12.9163V5.41667H8.23301L10.2497 7.44167L9.36634 8.33333L5.83301 4.79167L9.36634 1.25L10.2497 2.14167L8.23301 4.16667H14.1663Z" :fill="iconColor"/>
  </svg>
</template>

<script>
export default {
  props: {
    iconName: {
      type: String,
      default: "iconCreditCardRefund",
    },
    width: {
      type: [Number, String],
      default: 20,
    },
    height: {
      type: [Number, String],
      default: 20,
    },
    iconColor: {
      type: String,
      default: "currentColor",
    },
  },
};
</script>
